export default __webpack_public_path__ + "static/media/virtual-tour-slide-2-desktop.14f3e07e.png";